module.exports = __webpack_public_path__ + "img/kyzkzmix.626b91bc.jpg";